<!-- @format -->
@if (shouldShowButton()) {
	<product-reviews-social-images-modal></product-reviews-social-images-modal>

	<div class="hmf-display-flex">
		<span
			[ngClass]="{ 'hmf-ml-xxs': hasReviews() }"
			class="label-disabled hmf-display-flex hmf-align-items-center"
			>|</span
		>
		<button
			(click)="onClick()"
			class="hmf-body-m hmf-display-flex hmf-justify-content-center hmf-align-items-center">
			<homefield-icon
				width="20px"
				height="20px"
				[width]="isMobileSize() ? '16px' : '20px'"
				[height]="isMobileSize() ? '16px' : '20px'"
				name="recommendation-fire"
				fill="var(--hmf-yellow500)"></homefield-icon>
			<span class="hmf-body-m-m hmf-body-s">Hot on Social</span>
		</button>
	</div>
}
